<template>
  <multiselect
    v-model="rawVal"
    :options="options"
    :show-labels="false"
    placeholder="Seleccione una opción"
    select-label="<Enter> para seleccionar"
    selected-label="Seleccionado"
    deselect-label="<Enter> para remover"
    trackBy="title"
    label="title"
  >
    <template slot="option" slot-scope="props">
      <div class="columns">
        <div class="column is-size-7">
          {{ props.option.title }}
        </div>
        <div
          class="column has-text-right has-text-grey-lighter is-size-7"
          v-if="props.option.description"
        >
          {{ props.option.description }}
        </div>
      </div>
    </template>
    <template #noResult>
      No se encontraron resultados
    </template>
  </multiselect>
</template>

<script>
import SchemaFormElementMixin from '@/mixins/SchemaFormElementMixin'

export default {
  name: 'SchemaFormElementSelect',
  mixins: [SchemaFormElementMixin],
  props: {
    selectOptions: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      rawVal: undefined
    }
  },
  computed: {
    options() {
      if (this.selectOptions.length > 0) {
        return this.selectOptions
      }

      return this.schema.enum.map(val => {
        return {
          title: val,
          description: ''
        }
      })
    }
  },
  watch: {
    rawVal(newVal) {
      if (newVal) {
        this.val = newVal.title
      }
    }
  },
  created() {
    if (this.schema.default && !this.val && !this.value) {
      this.rawVal = {
        title: this.schema.default
      }

      if (typeof this.schema.examples !== 'undefined') {
        this.rawVal.description = this.schema.examples[
          this.schema.enum.indexOf(this.schema.default)
        ]
      } else {
        this.rawVal.description = ''
      }
    }
  }
}
</script>
